export const userInputs = [
  {
    id: 1,
    label: "Username",
    type: "text",
    placeholder: "Jon_Snow",
  },
  {
    id: 2,
    label: "Name and surname",
    type: "text",
    placeholder: "Jon Snow",
  },
  {
    id: 3,
    label: "Email",
    type: "mail",
    placeholder: "JonSnow@gmail.com",
  },
  {
    id: 4,
    label: "Phone",
    type: "text",
    placeholder: "+62 812 134",
  },
  {
    id: 5,
    label: "Password",
    type: "password",
  },
  {
    id: 6,
    label: "Address",
    type: "text",
    placeholder: "The Wall, Winterfell",
  },
  {
    id: 7,
    label: "Country",
    type: "text",
    placeholder: "Winterfell",
  },
];

export const productInputs = [
  {
    id: 1,
    label: "Title",
    type: "text",
    placeholder: "Apple Macbook Pro",
  },
  {
    id: 2,
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: 3,
    label: "Category",
    type: "text",
    placeholder: "Computers",
  },
  {
    id: 4,
    label: "Price",
    type: "text",
    placeholder: "100",
  },
  {
    id: 5,
    label: "Stock",
    type: "text",
    placeholder: "in stock",
  },
];
